export default parseInt;
//# sourceMappingURL=to-integer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/layout/node_modules/@antv/util/esm/lodash/to-integer.js
// module id = null
// module chunks = 